export default fields => (values, props) => {
  const errors = {}
  fields.forEach((field) => {
    field.validation.forEach((validation) => {
      const result = validation(values[field.name], values, props)
      if (!errors[field.name] && result) {
        errors[field.name] = result
      }
    })
  })
  return errors
}

export const validateGreaterThanOrEqualToZero = (v) => {
  if (v == null) {
    // Allow null values through, so that we don't provide superfluous validation messages. If a field
    // is required it should have an validation rule for being required
    return true
  }
  if (typeof v === 'string' && v.trim().length === 0) {
    return false
  }
  return !isNaN(Number(v)) && Number(v) >= 0
}



/** WEBPACK FOOTER **
 ** ./src/utils/validate/validate.js
 **/